<template>
  <div>
    <nav class="navbar navbar-expand-lg bg-light">
      <div class="container d-lg-flex align-items-lg-center content-space-t-3 content-space-lg-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-subtract" viewBox="0 0 16 16">
          <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/>
        </svg>
        <a class="navbar-brand" href="#" style="margin-left:10px; font-size: 20px;
    font-weight: 700;">PA SOFT</a>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
<!--            <li class="nav-item">-->
<!--              <router-link to="login" style="padding-left:0px;" class="nav-link">Solution Log-in</router-link>-->
<!--            </li>-->

          </ul>

        </div>
        <div class="d-grid d-sm-flex gap-3">

        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
    <TopPage/>
    <MiddlePage/>
    <MiddleDesc/>
    <MiddlePage02/>

    <div id="M_footer" style="color:#92a3bb">
      Copyright 2023. PA Soft Inc. all rights reserved.
    </div>
  </div>

</template>

<script>
import MiddlePage from "./pageModule/MiddlePage";
import MiddlePage02 from "./pageModule/MiddlePage02";
import MiddleDesc from "./pageModule/MiddleDesc";
import TopPage from "./pageModule/TopPage";

export default {
  name: 'Company',
  data() {

    return {
      context:'',
      conLength:0,

    }
  },
  mounted: function () {

  },

  methods:{

  },
  components: {
    MiddlePage,MiddlePage02,MiddleDesc,TopPage
  }
}

</script>

<style scoped>
#M_footer{
  padding-top:0px;
  font-size: 12px;
  height:5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top:1px solid #92a3bb;
}
</style>

